import { render, staticRenderFns } from "./FindingCommentList.vue?vue&type=template&id=1323e18a&scoped=true"
import script from "./FindingCommentList.vue?vue&type=script&lang=js"
export * from "./FindingCommentList.vue?vue&type=script&lang=js"
import style0 from "./FindingCommentList.vue?vue&type=style&index=0&id=1323e18a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323e18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1323e18a')) {
      api.createRecord('1323e18a', component.options)
    } else {
      api.reload('1323e18a', component.options)
    }
    module.hot.accept("./FindingCommentList.vue?vue&type=template&id=1323e18a&scoped=true", function () {
      api.rerender('1323e18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/FindingCommentList.vue"
export default component.exports